export default __webpack_public_path__ + "static/media/toinhabrasilshow-deck-300x225.59a7948f.png";